import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActionsAgent = ({ 
  onRegisterCustomer,
  onSendMoney,
  onDownloadKit,
  onRequestPayout,
  onViewNotifications
}) => {
  const quickActions = [
    {
      title: 'Register New Customer',
      description: 'Onboard a new customer to your network',
      icon: 'UserPlus',
      color: 'bg-primary text-white',
      onClick: () => onRegisterCustomer?.(),
      badge: 'Popular'
    },
    {
      title: 'Send Money',
      description: 'Process a money transfer for a customer',
      icon: 'Send',
      color: 'bg-success text-white',
      onClick: () => onSendMoney?.(),
    },
    {
      title: 'Download Marketing Kit',
      description: 'Get promotional materials and brochures',
      icon: 'Download',
      color: 'bg-accent text-white',
      onClick: () => onDownloadKit?.(),
    },
    {
      title: 'Request Commission Payout',
      description: 'Withdraw your earned commissions',
      icon: 'CreditCard',
      color: 'bg-warning text-white',
      onClick: () => onRequestPayout?.(),
      badge: 'Available'
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-foreground mb-2">Quick Actions</h2>
        <p className="text-muted-foreground text-sm">
          Common tasks and tools to help you serve customers efficiently.
        </p>
      </div>

      {/* Primary Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions?.map((action, index) => (
          <div
            key={index}
            className="group bg-card rounded-lg border border-border p-6 hover:shadow-lg transition-all duration-200 cursor-pointer"
            onClick={action?.onClick}
          >
            {/* Badge */}
            {action?.badge && (
              <div className="flex justify-end mb-2">
                <span className="px-2 py-1 text-xs bg-primary/10 text-primary rounded-full">
                  {action?.badge}
                </span>
              </div>
            )}

            {/* Icon */}
            <div className={`
              w-12 h-12 rounded-lg flex items-center justify-center mb-4 transition-colors duration-200
              ${action?.color} group-hover:scale-110
            `}>
              <Icon name={action?.icon} size={24} />
            </div>

            {/* Content */}
            <div className="space-y-2">
              <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors duration-200">
                {action?.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {action?.description}
              </p>
            </div>

            {/* Arrow Indicator */}
            <div className="flex justify-end mt-4">
              <Icon 
                name="ArrowRight" 
                size={16} 
                className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-200" 
              />
            </div>
          </div>
        ))}
      </div>

      {/* Agent Alerts */}
      <div className="bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="Bell" size={16} className="text-white" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-blue-900 mb-1">Agent Notifications</h4>
            <div className="space-y-2 text-sm text-blue-800">
              <div className="flex items-start space-x-2">
                <Icon name="Dot" size={12} className="mt-1.5" />
                <span>New promotional rates effective December 1st - up to 0.5% bonus commission</span>
              </div>
              <div className="flex items-start space-x-2">
                <Icon name="Dot" size={12} className="mt-1.5" />
                <span>Monthly agent training webinar scheduled for November 25th at 2:00 PM EST</span>
              </div>
              <div className="flex items-start space-x-2">
                <Icon name="Dot" size={12} className="mt-1.5" />
                <span>Q4 performance bonuses now available - check your commission tracker</span>
              </div>
            </div>
            <div className="mt-3">
              <Button
                variant="outline"
                size="sm"
                className="text-blue-700 border-blue-300 hover:bg-blue-50"
                iconName="ExternalLink"
                iconPosition="right"
                onClick={onViewNotifications}
              >
                View All Notifications
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsAgent;